<template>
  <v-dialog v-model="user_modal_shown" max-width="500" transition="dialog-bottom-transition">
    <v-card>
      <v-card-title class="headline">Add user record</v-card-title>
      <v-card-text>
        <v-form v-model="valid">
          <v-text-field v-model="add_user_email"
                        type="email"
                        required
                        :rules="email_rules"
                        prepend-icon="mail"
                        v-on:keyup.enter.prevent.native="saveUser"
                        label="User Email"></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!valid"
          color="primary"
          @click="saveUser">
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "AddUserModal",
    data: function () {
      return {
        valid: false,
      }
    },
    methods:
      {
        saveUser() {
          this.$store.dispatch('saveAddUserModal')
        }
      },
    computed: {
      ...mapGetters([
        'addUserEmail',
        'addUserModalShown'
      ]),
      email_rules() {
        return [
          v => !!v || 'Email is required',
          v => (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || 'Email must be valid'
        ]
      },
      user_modal_shown: {
        'set': function (new_value) {
          this.$store.dispatch('hideAddUserModal')
        },
        'get': function () {
          return this.addUserModalShown
        }
      },
      add_user_email: {
        'set': function (new_value) {
          this.$store.dispatch('setUserEmail', new_value)
        },
        'get': function () {
          return this.addUserEmail
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/Users/AddUserModal.vue